import React, { useEffect, useState } from 'react';
import { adminApi } from '../../utils/api';

export default function AdminSettingsPage() {
  const [settings, setSettings] = useState(null);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    adminApi.getSettings().then(r => setSettings(r.data)).catch(console.error);
  }, []);

  const set = (field, value) => setSettings(s => ({ ...s, [field]: value }));

  const handleSave = async () => {
    setSaving(true);
    try {
      await adminApi.updateSettings(settings);
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch { alert('Failed to save settings.'); }
    finally { setSaving(false); }
  };

  if (!settings) return <div className="page-loading"><div className="spinner" /></div>;

  return (
    <div style={{ padding: 24, maxWidth: 640 }}>
      <h1 style={{ fontSize: 22, marginBottom: 4 }}>Campaign Settings</h1>
      <p className="text-muted text-small" style={{ marginBottom: 24 }}>Configure the initiative campaign parameters</p>

      <div className="card" style={{ marginBottom: 16 }}>
        <h3 style={{ fontSize: 13, fontWeight: 600, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '.5px', marginBottom: 16 }}>Campaign Details</h3>
        <div className="field">
          <label>Campaign Title</label>
          <input type="text" value={settings.campaign_title || ''} onChange={e => set('campaign_title', e.target.value)} />
        </div>
        <div className="field-row">
          <div className="field">
            <label>Application Deadline</label>
            <input type="date" value={settings.application_deadline?.slice(0,10) || ''} onChange={e => set('application_deadline', e.target.value)} />
          </div>
          <div className="field">
            <label>Max Selected Businesses</label>
            <input type="number" min={1} value={settings.max_selected_businesses || 10} onChange={e => set('max_selected_businesses', parseInt(e.target.value))} />
          </div>
        </div>
        <div className="field">
          <label>Notification Email Recipients</label>
          <input type="text" value={(settings.notification_emails || []).join(', ')}
            onChange={e => set('notification_emails', e.target.value.split(',').map(s => s.trim()).filter(Boolean))}
            placeholder="admin@adeona.lk, team@adeona.lk" />
          <div className="hint">Comma-separated email addresses</div>
        </div>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <h3 style={{ fontSize: 13, fontWeight: 600, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '.5px', marginBottom: 16 }}>Content</h3>
        <div className="field">
          <label>Thank You Message</label>
          <textarea value={settings.thank_you_message || ''} onChange={e => set('thank_you_message', e.target.value)} style={{ minHeight: 100 }} />
        </div>
        <div className="field">
          <label>Terms & Conditions</label>
          <textarea value={settings.terms_conditions || ''} onChange={e => set('terms_conditions', e.target.value)} style={{ minHeight: 120 }} />
        </div>
      </div>

      <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
        <button className="btn btn--primary" onClick={handleSave} disabled={saving}>
          {saving ? 'Saving...' : 'Save Settings'}
        </button>
        {saved && <span style={{ fontSize: 13, color: 'var(--accent)' }}>✓ Settings saved</span>}
      </div>
    </div>
  );
}
